import { RequisitionPrecedentFieldNames } from '@models/requisitions';
import { ParcelInstrument } from '@models/teranet';
import { TeranetRequisionFieldsToRequisitionPrecedentFieldName } from '@models/teranet-requisitions';
import { dollarsToCents } from './money';

export const getRequisitionFieldsFromParcelInstrument = (
	parcelInstrument: ParcelInstrument,
) => {
	const fields = {};
	for (const key of Object.keys(parcelInstrument)) {
		const fieldKey = TeranetRequisionFieldsToRequisitionPrecedentFieldName[key];
		if (fieldKey) {
			let fieldValue: string | number;
			switch (fieldKey) {
				case RequisitionPrecedentFieldNames.PARTY_TO:
				case RequisitionPrecedentFieldNames.PARTY_FROM:
					fieldValue = parcelInstrument[key].join(' ');
					break;

				case RequisitionPrecedentFieldNames.INSTRUMENT_AMOUNT:
					fieldValue = dollarsToCents(parcelInstrument[key]);
					break;

				case RequisitionPrecedentFieldNames.REGISTRATION_DATE:
					fieldValue = parcelInstrument[key].replace(/\//g, '-');
					break;

				default:
					fieldValue = parcelInstrument[key];
					break;
			}
			fields[fieldKey] = fieldValue;
		}
	}

	return fields;
};
